import React from 'react'
import styles from './RecipientCard.styles'
import CardWCheckbox from '../../../../components/card/cardwcheckbox/CardWCheckbox'
import Payer from "../../../../../libs/utility/Payer"
import Label from '../../../../components/label/Label'
import VerticalSeparator from '../../../../components/separator/verticalseparator/VerticalSeparator'

export default function RecipientCard({
    recipient = {},
    isSelected = false,
    onChangeCheckboxCb = () => { },
    onCardClickCb = () => { },
    isHighlighted = false,
    hideTin = true
}) {

    const { FirstName = "", LastName, TypeofTIN, IdNumber, FileType, IdType, FilerType, MiddleName } = recipient;

    return (
        <>
            <CardWCheckbox
                isSelected={isSelected}
                onChangeCb={onChangeCheckboxCb}
                isHighlighted={isHighlighted}
                onCardClickCb={onCardClickCb}
                containerStyle={styles.cursor}
            >

                <div style={styles.recipientInformationContainer}>
                    <Label customStyles={styles.recipientName}>{FirstName} {MiddleName && `${MiddleName} `}{LastName}</Label>

                    <div style={styles.detailsContainer}>
                        <div style={styles.recipientType}>
                            {/* <span>{`${TypeofTIN == "SSN" ? "Individual" : "Business"}`}</span> */}
                            <span>{FilerType}</span>
                            <VerticalSeparator style={styles.separator} />

                            <div style={styles.gapBetween}>
                                <span>
                                    {Payer.getPayerTINByIdType(FilerType, IdNumber, hideTin) || "N/A"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </CardWCheckbox>
        </>
    )
}